import { Yup } from 'app/components/core/Form';
import { SnowflakeSchemaFqnObject } from './common.js';

export const RoleAndWarehouseFormFieldsSchema = Yup.object({
    role: Yup.string().required('deployTransformation:formFields.role.required'),
    warehouse: Yup.string().required('deployTransformation:formFields.warehouse.required')
});

export const DeployTransformationSchema = Yup.object({
    tableName: Yup.string()
        .required('deployTransformation:formFields.name.required')
        .min(3, 'deployTransformation:formFields.name.min')
        .max(100, 'deployTransformation:formFields.name.max')
        .matches(/^[A-Za-z_]/, 'deployTransformation:formFields.name.startsWithCharacter')
        .matches(/^(.[\w]*)?$/, 'deployTransformation:formFields.name.contains'),
    destination: SnowflakeSchemaFqnObject.required(),
    deploymentMessage: Yup.string(),
    targetLag: Yup.string()
}).concat(RoleAndWarehouseFormFieldsSchema);
